const API_CONFIG = {
  development: {
    baseURL: "http://localhost:7001/admin",
  },
  production: {
    baseURL: "https://new-be.lotusmart.ae/admin",
  },
};

const environment = "development";
// const environment = import.meta.env.MODE || "development";

export const BASE_URL =
  API_CONFIG[environment]?.baseURL || API_CONFIG.development.baseURL;

export const SOCKET_URL = BASE_URL.replace("/admin", "/admin-chat");

export default API_CONFIG;
